import { useTranslation } from 'react-i18next';

import type { StreamType } from '~/modules/artist-roster/components/LineGraph/LineGraph';
import { BarChartTooltip } from '~/modules/artist-roster/pages/track-details/components/BarChartTooltip';
import type { DSPData } from '~/modules/artist-roster/pages/track-details/mockData/mockData';

import { DSPIcon } from './DSPIcon';

interface DSPTooltipProps {
  dsp: string;
  data: DSPData;
  totalStreams: number;
  streamType: StreamType;
}

export function DSPTooltip(props: DSPTooltipProps) {
  const { t } = useTranslation('names');

  return (
    <BarChartTooltip
      header={
        <>
          <DSPIcon type={props.dsp} className="w-lg" />
          {t(props.dsp)}
        </>
      }
      {...props}
    />
  );
}

DSPTooltip.displayName = 'DSPTooltip';
